export function routes($stateProvider) {
    $stateProvider
        .state('app.crm.cotacoes', {
        url: '/empresas/{idEmpresa:int}/cotacoes',
        abstract: true
    })
        .state('app.crm.cotacoes.details', {
        url: '/{id:int}',
        title: 'Detalhes da Cotação',
        template: '<crm-cotacoes-details-view></crm-cotacoes-details-view>',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.crm.cotacoesGlobal', {
        url: '/cotacoes?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Cotações',
        template: '<crm-cotacoes-list-view></crm-cotacoes-list-view>',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.crm.cotacoes.formEdit', {
        url: '/form/edit/{id:int}',
        title: 'Formulário Cotação',
        template: '<crm-cotacao-form></crm-cotac-form>',
        // role: ['gasVerClientes'],
    })
        .state('app.crm.cotacoes.formCreate', {
        url: '/form/create',
        title: 'Formulário Cotação',
        template: '<crm-cotacao-form></crm-cotac-form>',
        // role: ['gasVerClientes'],
    });
}
routes.$inject = ['$stateProvider'];
